import React, { useCallback, useEffect } from "react";
import { Grid} from "semantic-ui-react";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import { HeaderForm } from "@EUForms/header";
import { useDispatch, useSelector } from "react-redux";
import { updateShipmentFieldValue } from "../../reducer/headerSlice";
import { useEvent } from "@hooks/useEvent"
import { selectHeaderTabDS, selectProcedureList } from "@EUForms/selectors";
import DatePicker from "@commonComponents/formComponents/CustomDatePicker";
import RepeatableContainer from "@containers/repeatableContainer";
import ExitInformationDetail from "./exitInformationDetail";
import { addItemHeader, updateItemHeader, deleteItemHeader } from '../../reducer/headerSlice'
import { useDocument } from '@EUForms/hooks/useDocument'
import { CustomLoader } from "@commonComponents/formComponents/loader";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";
import NLDMSStartJobButton from "../../../../header/ButtonMapper/NLDMSStartJobButton";
import { selectFilterTransmisisonTypeList } from "../../selectors";

const Header = (props) => {
  const { 
    translate, 
    jobWheels, 
    kxUser, 
    shipmentId, 
    version, 
    serviceType, 
    isImportShipment, 
    lowerEnv,
    shipId
  }= props
  const { saveForm } = useEvent("headerTab")
  const { currentJobData,currentJobState,isDisabled} = useCurrentShipmentType()
  const { isLoading, ...rest } = useDocument({
    addData: addItemHeader,
    updateData: updateItemHeader,
    deleteData: deleteItemHeader,
    containerKey: 'headerTab',
  })
  const dispatch = useDispatch()
  const enableExitInfo =["STATE_ENTRY_EXT_IN_PROCESS","STATE_ENTRY_EXT_READY"].includes(currentJobState)

  const dataSource = useSelector(selectHeaderTabDS)
  const procedureList = useSelector(selectProcedureList)
  const isEmergencyProcedure = useSelector(selectHeaderTabDS)?.emergencyProcedure || false

  const entryState = jobWheels["ES_ENTRY_JOB_WHEEL"]?.value?.state || ""
  const customState = jobWheels["NL_CUSTOM_JOB_WHEEL"]?.value?.state || ""
  const transmissionTypeList = useSelector((state) =>
    selectFilterTransmisisonTypeList(state, { entryState, customState })
    // selectFilterTransmisisonTypeList(state, { entryState, customState:'STATE_DMS_528ACC' }) // to be dynamic
  )

  const onSelect = (e, { value, name }) => {
    dispatch(updateShipmentFieldValue({ [name]: value?.trim() }))
    saveForm({ [name]: value || " " })
  }

  useEffect(() => {
    const initializeDefaultFields = () => {
      const updateFields = {}
      if (!dataSource.procedure)
        updateFields.procedure = isImportShipment ? "H1" : "B1"
      if (!dataSource.declType)
        updateFields.declType = "A"
      if (!dataSource.transmissionType)
        updateFields.transmissionType = "NEW"
      // if (transmissionTypeList?.length === 1)
      //   updateFields.transmissionType = transmissionTypeList[0]?.value

      if (Object.keys(updateFields).length > 0) {
        dispatch(updateShipmentFieldValue(updateFields))
        saveForm(updateFields)
      }
    }
    initializeDefaultFields()
  }, [])

  const renderActionBtns = useCallback(() => {
    return <NLDMSStartJobButton
      shipId={shipId}
      isImportShipment={isImportShipment}
      procedure={dataSource?.procedure}
      jobWheels={jobWheels}
      kxUser={kxUser}
      declType={dataSource?.declType}
      transmissionType={dataSource?.transmissionType}
      isCCDocEndRequest={dataSource?.isCCDocEndRequest}
      version={version}
      serviceType={serviceType}
      translate={translate}
      lowerEnv={lowerEnv}
      isEmergencyProcedure={isEmergencyProcedure}
    />
  }, [jobWheels,
    kxUser,
    shipmentId,
    dataSource?.declType,
    dataSource?.transmissionType,
    dataSource?.isCCDocEndRequest,
    version,
    serviceType,
    currentJobData,
    isEmergencyProcedure
  ])

  const renderAtFirst = useCallback(({ onSelect }) => {
    return (
      <Grid.Column>
        <DropDown
          id="procedure"
          name="procedure"
          label={translate("PROCEDURE")}
          labelClass="text-none"
          data={procedureList}
          value={dataSource.procedure}
          text={dataSource.procedure}
          onChange={onSelect}
        />
      </Grid.Column>
    )
  }, [dataSource.procedure, procedureList])

  const renderAtLast = useCallback(({ onSelect }) => {
    if (!isImportShipment && dataSource.transmissionType == "EXT") {
      return (<Grid.Column>
        <DatePicker
          id={`exitDate`}
          name="exitDate"
          type="date"
          label={translate("DATE_OF_EXIT", { ns: ["default", "header"] })}
          clearInput={true}
          value={dataSource?.exitDate}
          isDisabled={enableExitInfo?false:isDisabled}
          onChange={onSelect}
        />
      </Grid.Column>)
    } 
    // Removed acceptanceDate from UI as per CORE-20915
    // else if (isImportShipment) {
    //   return (
    //     <Grid.Column>
    //       <DatePicker
    //         id={`acceptanceDate`}
    //         name="acceptanceDate"
    //         type="date"
    //         label={translate("ACCEPTANCE_DATE", { ns: ["default", "header"] })}
    //         clearInput={true}
    //         value={dataSource?.acceptanceDate}
    //         onChange={onSelect}
    //       />
    //     </Grid.Column>
    //   )
    // }
     else return null

  }, [dataSource.transmissionType])
  
  return (
    <>
      {isLoading && <CustomLoader style={{ position: "fixed" }} />}
      <HeaderForm
        transmissionList={transmissionTypeList}
        onSelect={onSelect}
        renderActionBtns={renderActionBtns}
        renderAtFirst={renderAtFirst}
        renderAtLast={renderAtLast}
        translate={translate}
        disableFields={{ declaration: true }}
        dataSource={dataSource}
        jobWheels={jobWheels}
      />
      {(dataSource.transmissionType == "EXT" || ['STATE_DMS_599EXIT'].includes(customState)) &&
        <RepeatableContainer
          {...rest}
          tableName="exitInformation"
          reducerName="headerReducer"
          title="EXIT INFORMATION"
          translate={translate}
          maxRowsAllowed={10}
          isDisabled={enableExitInfo? false : isDisabled}
          renderForm={(params) => <ExitInformationDetail isDisabled={enableExitInfo? false : isDisabled}{...params} />}
        />}
      {/* {(dataSource.transmissionType == "CAN" && !isImportShipment) &&
        <Grid className="responsiveGridCss">
          <CancellationReasonForm />
        </Grid>} */}
    </>
  );
}

export default React.memo(Header)
